import { makeStyles } from '../styles';
import { resolveThemeColorProp } from '../utils/resolveThemeColorProp';

const ALIGN_MAP = {
  C: 'center',
  R: 'right',
}

export const useStyles = makeStyles([
  [
    'typography',
    (theme, [variant, color, weight, gutterBottom, noWrap, align]) => {
      const fontSize = (theme.typography.fontSize as any)[variant];
      const fontWeight = (theme.typography.fontWeight as any)[weight];
      const lineHeight = fontSize + 8;
      const textAlign = (ALIGN_MAP as any)[align];
      // On IE11, it's height may be strange when inserted an image children whose width > height.
      // The solution is to add min-height 0.01px. I don't know how it works.
      return [
        `
				color: ${resolveThemeColorProp(theme, color) || 'inherit'};
				font-weight: ${fontWeight};
				font-size: ${fontSize}px;
				line-height: ${lineHeight}px;
				min-height: 0.01px;
				margin: 0;
				margin-bottom: ${gutterBottom ? '0.35em' : 0};
			`,
        noWrap &&
          `
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			`,
        textAlign && `text-align: ${textAlign}`
      ];
    }
  ]
]);
